import React, { useState, useMemo } from 'react';
import Icon from '../../../components/AppIcon';

const emirateCostData = {
  Dubai: {
    label: 'Dubai',
    currency: 'AED',
    costs: {
      rent1BR: { min: 5000, max: 12000, avg: 8000, label: '1BR Apartment/mo' },
      rent2BR: { min: 8000, max: 20000, avg: 13000, label: '2BR Apartment/mo' },
      rent3BR: { min: 14000, max: 35000, avg: 22000, label: '3BR Apartment/mo' },
      groceries: { min: 1200, max: 2500, avg: 1800, label: 'Groceries/mo' },
      dining: { min: 1500, max: 4000, avg: 2500, label: 'Dining Out/mo' },
      transport: { min: 500, max: 1500, avg: 900, label: 'Transport/mo' },
      utilities: { min: 400, max: 1200, avg: 700, label: 'Utilities/mo' },
      schoolFees: { min: 25000, max: 80000, avg: 45000, label: 'School Fees/yr' },
      healthInsurance: { min: 2000, max: 8000, avg: 4000, label: 'Health Insurance/yr' },
    },
    notes: 'Most expensive emirate. Premium lifestyle hub with world-class amenities.',
    taxRate: 0,
    visaCost: 3000,
  },
  'Abu Dhabi': {
    label: 'Abu Dhabi',
    currency: 'AED',
    costs: {
      rent1BR: { min: 4500, max: 10000, avg: 7000, label: '1BR Apartment/mo' },
      rent2BR: { min: 7000, max: 16000, avg: 11000, label: '2BR Apartment/mo' },
      rent3BR: { min: 12000, max: 28000, avg: 18000, label: '3BR Apartment/mo' },
      groceries: { min: 1100, max: 2200, avg: 1600, label: 'Groceries/mo' },
      dining: { min: 1200, max: 3500, avg: 2200, label: 'Dining Out/mo' },
      transport: { min: 500, max: 1400, avg: 850, label: 'Transport/mo' },
      utilities: { min: 350, max: 1000, avg: 600, label: 'Utilities/mo' },
      schoolFees: { min: 22000, max: 70000, avg: 40000, label: 'School Fees/yr' },
      healthInsurance: { min: 1800, max: 7000, avg: 3500, label: 'Health Insurance/yr' },
    },
    notes: 'Capital city. Slightly lower cost than Dubai with strong government infrastructure.',
    taxRate: 0,
    visaCost: 3000,
  },
  Sharjah: {
    label: 'Sharjah',
    currency: 'AED',
    costs: {
      rent1BR: { min: 2000, max: 5000, avg: 3200, label: '1BR Apartment/mo' },
      rent2BR: { min: 3500, max: 8000, avg: 5500, label: '2BR Apartment/mo' },
      rent3BR: { min: 5500, max: 12000, avg: 8000, label: '3BR Apartment/mo' },
      groceries: { min: 900, max: 1800, avg: 1300, label: 'Groceries/mo' },
      dining: { min: 800, max: 2500, avg: 1500, label: 'Dining Out/mo' },
      transport: { min: 600, max: 1600, avg: 1000, label: 'Transport/mo (commute to Dubai)' },
      utilities: { min: 300, max: 800, avg: 500, label: 'Utilities/mo' },
      schoolFees: { min: 12000, max: 40000, avg: 22000, label: 'School Fees/yr' },
      healthInsurance: { min: 1500, max: 5000, avg: 2800, label: 'Health Insurance/yr' },
    },
    notes: 'Most affordable near Dubai. Many expats commute to Dubai. Conservative lifestyle.',
    taxRate: 0,
    visaCost: 2500,
  },
  Ajman: {
    label: 'Ajman',
    currency: 'AED',
    costs: {
      rent1BR: { min: 1500, max: 4000, avg: 2500, label: '1BR Apartment/mo' },
      rent2BR: { min: 2500, max: 6000, avg: 4000, label: '2BR Apartment/mo' },
      rent3BR: { min: 4000, max: 9000, avg: 6000, label: '3BR Apartment/mo' },
      groceries: { min: 800, max: 1600, avg: 1200, label: 'Groceries/mo' },
      dining: { min: 700, max: 2000, avg: 1200, label: 'Dining Out/mo' },
      transport: { min: 700, max: 1800, avg: 1100, label: 'Transport/mo (commute)' },
      utilities: { min: 250, max: 700, avg: 450, label: 'Utilities/mo' },
      schoolFees: { min: 10000, max: 30000, avg: 18000, label: 'School Fees/yr' },
      healthInsurance: { min: 1200, max: 4500, avg: 2500, label: 'Health Insurance/yr' },
    },
    notes: 'Most affordable emirate. Ideal for budget-conscious expats. Longer commute to Dubai.',
    taxRate: 0,
    visaCost: 2000,
  },
  'Ras Al Khaimah': {
    label: 'Ras Al Khaimah',
    currency: 'AED',
    costs: {
      rent1BR: { min: 2000, max: 5500, avg: 3500, label: '1BR Apartment/mo' },
      rent2BR: { min: 3500, max: 9000, avg: 6000, label: '2BR Apartment/mo' },
      rent3BR: { min: 6000, max: 14000, avg: 9000, label: '3BR Apartment/mo' },
      groceries: { min: 900, max: 1800, avg: 1300, label: 'Groceries/mo' },
      dining: { min: 800, max: 2200, avg: 1400, label: 'Dining Out/mo' },
      transport: { min: 500, max: 1200, avg: 800, label: 'Transport/mo' },
      utilities: { min: 300, max: 800, avg: 500, label: 'Utilities/mo' },
      schoolFees: { min: 12000, max: 38000, avg: 22000, label: 'School Fees/yr' },
      healthInsurance: { min: 1500, max: 5000, avg: 2800, label: 'Health Insurance/yr' },
    },
    notes: 'Growing expat hub with casino resort development. Scenic mountains and beaches.',
    taxRate: 0,
    visaCost: 2500,
  },
  Fujairah: {
    label: 'Fujairah',
    currency: 'AED',
    costs: {
      rent1BR: { min: 1800, max: 4500, avg: 3000, label: '1BR Apartment/mo' },
      rent2BR: { min: 3000, max: 7500, avg: 5000, label: '2BR Apartment/mo' },
      rent3BR: { min: 5000, max: 12000, avg: 7500, label: '3BR Apartment/mo' },
      groceries: { min: 850, max: 1700, avg: 1250, label: 'Groceries/mo' },
      dining: { min: 700, max: 2000, avg: 1300, label: 'Dining Out/mo' },
      transport: { min: 600, max: 1500, avg: 900, label: 'Transport/mo' },
      utilities: { min: 280, max: 750, avg: 480, label: 'Utilities/mo' },
      schoolFees: { min: 10000, max: 32000, avg: 18000, label: 'School Fees/yr' },
      healthInsurance: { min: 1200, max: 4500, avg: 2500, label: 'Health Insurance/yr' },
    },
    notes: 'East coast emirate on Gulf of Oman. Quieter lifestyle, strong port economy.',
    taxRate: 0,
    visaCost: 2000,
  },
  'Umm Al Quwain': {
    label: 'Umm Al Quwain',
    currency: 'AED',
    costs: {
      rent1BR: { min: 1200, max: 3500, avg: 2200, label: '1BR Apartment/mo' },
      rent2BR: { min: 2000, max: 5500, avg: 3500, label: '2BR Apartment/mo' },
      rent3BR: { min: 3500, max: 8000, avg: 5500, label: '3BR Apartment/mo' },
      groceries: { min: 750, max: 1500, avg: 1100, label: 'Groceries/mo' },
      dining: { min: 600, max: 1800, avg: 1100, label: 'Dining Out/mo' },
      transport: { min: 700, max: 1800, avg: 1100, label: 'Transport/mo (commute)' },
      utilities: { min: 250, max: 650, avg: 420, label: 'Utilities/mo' },
      schoolFees: { min: 8000, max: 25000, avg: 15000, label: 'School Fees/yr' },
      healthInsurance: { min: 1000, max: 4000, avg: 2200, label: 'Health Insurance/yr' },
    },
    notes: 'Smallest and most affordable emirate. Very quiet, limited amenities. Ideal for low-cost living.',
    taxRate: 0,
    visaCost: 1800,
  },
};

const ExpatCostCalculator = () => {
  const [selectedEmirate, setSelectedEmirate] = useState('Dubai');
  const [lifestyle, setLifestyle] = useState('avg');
  const [hasChildren, setHasChildren] = useState(false);
  const [familySize, setFamilySize] = useState(1);
  const [isCalculating, setIsCalculating] = useState(false);

  const data = emirateCostData?.[selectedEmirate];

  const triggerCalculation = (fn) => {
    setIsCalculating(true);
    fn();
    setTimeout(() => setIsCalculating(false), 500);
  };

  const monthlyCosts = useMemo(() => {
    const key = lifestyle;
    const c = data?.costs;
    const rentKey = familySize <= 1 ? 'rent1BR' : familySize <= 3 ? 'rent2BR' : 'rent3BR';
    const rent = c?.[rentKey]?.[key];
    const groceries = c?.groceries?.[key] * Math.max(1, familySize * 0.7);
    const dining = c?.dining?.[key] * Math.max(1, familySize * 0.6);
    const transport = c?.transport?.[key];
    const utilities = c?.utilities?.[key];
    const schoolMonthly = hasChildren ? (c?.schoolFees?.[key] / 12) * Math.max(1, familySize - 1) : 0;
    const healthMonthly = (c?.healthInsurance?.[key] / 12) * familySize;
    const total = rent + groceries + dining + transport + utilities + schoolMonthly + healthMonthly;
    return { rent, groceries: Math.round(groceries), dining: Math.round(dining), transport, utilities, schoolMonthly: Math.round(schoolMonthly), healthMonthly: Math.round(healthMonthly), total: Math.round(total) };
  }, [selectedEmirate, lifestyle, hasChildren, familySize, data]);

  const fmt = (n) => Math.round(n)?.toLocaleString('en-AE');

  const costItems = [
    { label: familySize <= 1 ? '1BR Rent' : familySize <= 3 ? '2BR Rent' : '3BR Rent', value: monthlyCosts?.rent, icon: 'Home', color: '#00D4FF' },
    { label: 'Groceries', value: monthlyCosts?.groceries, icon: 'ShoppingCart', color: '#00FF88' },
    { label: 'Dining Out', value: monthlyCosts?.dining, icon: 'UtensilsCrossed', color: '#FFC800' },
    { label: 'Transport', value: monthlyCosts?.transport, icon: 'Car', color: '#A78BFA' },
    { label: 'Utilities', value: monthlyCosts?.utilities, icon: 'Zap', color: '#F97316' },
    ...(hasChildren ? [{ label: 'School Fees', value: monthlyCosts?.schoolMonthly, icon: 'GraduationCap', color: '#EC4899' }] : []),
    { label: 'Health Insurance', value: monthlyCosts?.healthMonthly, icon: 'Heart', color: '#EF4444' },
  ];

  return (
    <div className="rounded-2xl p-6 md:p-8" style={{ background: 'rgba(10, 22, 40, 0.9)', border: '1px solid rgba(0, 212, 255, 0.2)' }}>
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: 'rgba(0, 212, 255, 0.1)', border: '1px solid rgba(0, 212, 255, 0.3)' }}>
          <Icon name="Wallet" size={20} color="#00D4FF" />
        </div>
        <div>
          <h3 className="text-lg font-bold" style={{ color: '#E8F4FF' }}>Expat Cost of Living Calculator</h3>
          <p className="text-sm" style={{ color: '#6B9EC4' }}>Monthly living costs across all 7 UAE emirates</p>
        </div>
      </div>
      {/* Emirate Selector */}
      <div className="mb-5">
        <label className="text-xs font-medium mb-2 block" style={{ color: '#6B9EC4' }}>Select Emirate</label>
        <div className="flex flex-wrap gap-2">
          {Object.keys(emirateCostData)?.map(emirate => (
            <button
              key={emirate}
              onClick={() => triggerCalculation(() => setSelectedEmirate(emirate))}
              className="px-3 py-1.5 rounded-lg text-xs font-medium transition-all duration-200"
              style={selectedEmirate === emirate
                ? { background: 'rgba(0,212,255,0.2)', border: '1px solid rgba(0,212,255,0.6)', color: '#00D4FF' }
                : { background: 'rgba(0,212,255,0.04)', border: '1px solid rgba(0,212,255,0.15)', color: '#6B9EC4' }
              }
            >
              {emirate}
            </button>
          ))}
        </div>
        <p className="text-xs mt-2" style={{ color: '#4A7A9B' }}>{data?.notes}</p>
      </div>
      {/* Controls */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        <div>
          <label className="text-xs font-medium mb-2 block" style={{ color: '#6B9EC4' }}>Lifestyle</label>
          <div className="flex gap-1">
            {[{ key: 'min', label: 'Budget' }, { key: 'avg', label: 'Average' }, { key: 'max', label: 'Luxury' }]?.map(l => (
              <button
                key={l?.key}
                onClick={() => triggerCalculation(() => setLifestyle(l?.key))}
                className="flex-1 py-2 rounded-lg text-xs font-medium transition-all duration-200"
                style={lifestyle === l?.key
                  ? { background: 'rgba(0,212,255,0.2)', border: '1px solid rgba(0,212,255,0.5)', color: '#00D4FF' }
                  : { background: 'rgba(0,212,255,0.04)', border: '1px solid rgba(0,212,255,0.12)', color: '#6B9EC4' }
                }
              >
                {l?.label}
              </button>
            ))}
          </div>
        </div>
        <div>
          <label className="text-xs font-medium mb-2 block" style={{ color: '#6B9EC4' }}>Family Size: {familySize} {familySize === 1 ? 'person' : 'people'}</label>
          <input
            type="range" min={1} max={6} value={familySize}
            onChange={e => setFamilySize(parseInt(e?.target?.value))}
            className="w-full"
          />
          <div className="flex justify-between text-xs" style={{ color: '#4A7A9B' }}><span>1</span><span>6</span></div>
        </div>
        <div>
          <label className="text-xs font-medium mb-2 block" style={{ color: '#6B9EC4' }}>School-Age Children</label>
          <button
            onClick={() => setHasChildren(!hasChildren)}
            className="w-full py-2 rounded-lg text-xs font-medium transition-all duration-200"
            style={hasChildren
              ? { background: 'rgba(0,212,255,0.2)', border: '1px solid rgba(0,212,255,0.5)', color: '#00D4FF' }
              : { background: 'rgba(0,212,255,0.04)', border: '1px solid rgba(0,212,255,0.12)', color: '#6B9EC4' }
            }
          >
            {hasChildren ? '✓ Include School Fees' : 'No School Fees'}
          </button>
        </div>
      </div>
      {/* Cost Breakdown */}
      {isCalculating ? (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-5 animate-pulse">
          {[...Array(6)]?.map((_, idx) => (
            <div key={idx} className="flex items-center justify-between p-3 rounded-xl" style={{ background: 'rgba(0,212,255,0.04)', border: '1px solid rgba(0,212,255,0.1)' }}>
              <div className="flex items-center gap-2">
                <div className="w-7 h-7 rounded-lg" style={{ background: 'rgba(0,212,255,0.1)' }} />
                <div className="h-3 w-20 rounded" style={{ background: 'rgba(0,212,255,0.1)' }} />
              </div>
              <div className="h-4 w-24 rounded" style={{ background: 'rgba(0,212,255,0.1)' }} />
            </div>
          ))}
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-5">
          {costItems?.map((item, idx) => (
            <div key={idx} className="flex items-center justify-between p-3 rounded-xl" style={{ background: 'rgba(0, 212, 255, 0.04)', border: '1px solid rgba(0, 212, 255, 0.1)' }}>
              <div className="flex items-center gap-2">
                <div className="w-7 h-7 rounded-lg flex items-center justify-center" style={{ background: `${item?.color}15` }}>
                  <Icon name={item?.icon} size={14} color={item?.color} />
                </div>
                <span className="text-sm" style={{ color: '#6B9EC4' }}>{item?.label}</span>
              </div>
              <span className="text-sm font-bold" style={{ color: '#E8F4FF', fontFamily: "'JetBrains Mono', monospace" }}>AED {fmt(item?.value)}</span>
            </div>
          ))}
        </div>
      )}
      {/* Total */}
      {isCalculating ? (
        <div className="p-4 rounded-xl text-center animate-pulse" style={{ background: 'rgba(0,212,255,0.1)', border: '1px solid rgba(0,212,255,0.4)' }}>
          <div className="h-3 w-48 rounded mx-auto mb-2" style={{ background: 'rgba(0,212,255,0.2)' }} />
          <div className="h-9 w-40 rounded mx-auto mb-2" style={{ background: 'rgba(0,212,255,0.2)' }} />
          <div className="h-3 w-36 rounded mx-auto" style={{ background: 'rgba(0,212,255,0.15)' }} />
        </div>
      ) : (
        <div className="p-4 rounded-xl text-center" style={{ background: 'rgba(0, 212, 255, 0.1)', border: '1px solid rgba(0, 212, 255, 0.4)' }}>
          <div className="text-xs mb-1" style={{ color: '#6B9EC4' }}>Estimated Monthly Total — {selectedEmirate} ({lifestyle === 'min' ? 'Budget' : lifestyle === 'avg' ? 'Average' : 'Luxury'} Lifestyle)</div>
          <div className="text-3xl font-bold" style={{ color: '#00D4FF', fontFamily: "'JetBrains Mono', monospace" }}>AED {fmt(monthlyCosts?.total)}</div>
          <div className="text-sm mt-1" style={{ color: '#6B9EC4' }}>≈ AED {fmt(monthlyCosts?.total * 12)} per year</div>
        </div>
      )}
      {/* Emirate Comparison */}
      <div className="mt-5">
        <div className="text-xs font-semibold mb-3" style={{ color: '#6B9EC4' }}>EMIRATE COST COMPARISON (Average 1BR + Basic Living)</div>
        <div className="space-y-2">
          {Object.entries(emirateCostData)?.map(([emirate, eData]) => {
            const baseMonthly = eData?.costs?.rent1BR?.avg + eData?.costs?.groceries?.avg + eData?.costs?.transport?.avg + eData?.costs?.utilities?.avg;
            const maxBase = emirateCostData?.['Dubai']?.costs?.rent1BR?.avg + emirateCostData?.['Dubai']?.costs?.groceries?.avg + emirateCostData?.['Dubai']?.costs?.transport?.avg + emirateCostData?.['Dubai']?.costs?.utilities?.avg;
            const pct = Math.round((baseMonthly / maxBase) * 100);
            return (
              <div key={emirate} className="flex items-center gap-3">
                <div className="w-24 text-xs flex-shrink-0" style={{ color: emirate === selectedEmirate ? '#00D4FF' : '#6B9EC4' }}>{emirate}</div>
                <div className="flex-1 h-2 rounded-full" style={{ background: 'rgba(0,212,255,0.1)' }}>
                  <div className="h-2 rounded-full transition-all duration-300" style={{ width: `${pct}%`, background: emirate === selectedEmirate ? '#00D4FF' : 'rgba(0,212,255,0.4)' }} />
                </div>
                <div className="w-20 text-xs text-right" style={{ color: '#E8F4FF', fontFamily: "'JetBrains Mono', monospace" }}>AED {fmt(baseMonthly)}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ExpatCostCalculator;
